import { FavoriteMedicineCreateCommand } from '@dreryk/egabinet-prescription-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { medicineSelectorTranslationKeys } from '../../../../../../../translations';

export const useFavoriteMedicineCreateCommand = (
   medicineId: number,
   onSuccess?: VoidFunction,
   onUnexpectedError?: VoidFunction
): UseCqrsCommandResult<void, unknown> => {
   return useCqrsCommand<void, unknown>(
      () => {
         const command = new FavoriteMedicineCreateCommand();
         command.medicineId = medicineId;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(medicineSelectorTranslationKeys.table.addedMedicineToFavorites);
            onSuccess?.();
         },
         onUnexpectedError: onUnexpectedError,
      }
   );
};
